import { formatNumber } from 'core/service/lib/number-format'
import MESSAGES from 'core/data-model/constants/bi-messages'

const SummaryRow = ({
  id,
  productCode,
  productName,
  asterisks = '',
  coverageYear,
  paymentPeriod,
  selectedPlan,
  sumAssured,
  showSumAssuredDecimalPlaces,
  premium,
}) => {
  const getSumAssuredDisplayValue = () => {
    if (selectedPlan.planCode) {
      return MESSAGES.FLEXI_HEALTH_SUMMARY_BENEFIT_MESSAGE
    } else {
      if (showSumAssuredDecimalPlaces) {
        return formatNumber(sumAssured, 2)
      } else {
        return formatNumber(sumAssured)
      }
    }
  }
  const displayProductName = `${productName} (${productCode})${asterisks}`.replace(/\n/g, '<br>')
  return (
    <tr id={`summary-row-${id}`}>
      <td dangerouslySetInnerHTML={{ __html: displayProductName }}></td>
      <td>{coverageYear}</td>
      <td>{paymentPeriod}</td>
      <td>{getSumAssuredDisplayValue()}</td>
      <td>{formatNumber(premium, 2)}</td>
    </tr>
  )
}

export default SummaryRow
